import { render, staticRenderFns } from "./PDAsao.vue?vue&type=template&id=850d0e62&scoped=true&"
import script from "./PDAsao.vue?vue&type=script&lang=js&"
export * from "./PDAsao.vue?vue&type=script&lang=js&"
import style0 from "./PDAsao.vue?vue&type=style&index=0&id=850d0e62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "850d0e62",
  null
  
)

export default component.exports